import nathiers from "./images/nathiers.png";


const Nathier = ({breakPoints}) => {
  return (
    <div className={`flex justify-center items-center py-10 ${breakPoints}`}>
      {/* Updated this div for responsive grid layout */}
      <div className="grid grid-cols-1 md:grid-cols-5 gap-9">
        {/* First column now taking 1/3 of the space on medium devices and up */}
        <div className="md:col-span-2 text-black flex flex-col justify-center items-center">
          <img src={nathiers} alt="Mark Elliott" className="w-1/2 md:w-full" />
        </div>
        {/* Second column now taking 2/3 of the space on medium devices and up */}
        <div className="md:col-span-3 text-black flex flex-col justify-between">
          <div className="text-lg md:text-sm text-left font-markWebPro">
            <p className="pb-5">
            Top Employers Institute, the globally-recognized authority on certifying excellence in people strategies and practices, honored a total of 290 organizations across 31 African countries and 26 industries in 2024. This signifies a 6% increase, establishing a new record for the prestigious Top Employers Certification.
            </p>
            <p className="pb-5">
            The recently unveiled list of top employers on the continent saw Vodacom clinch the coveted first position in both Africa and South Africa, reaffirming its commitment to exemplary workplace standards. Headquartered in the Netherlands, the Top Employers Institute conducts an annual HR best practices survey among companies worldwide, aiding them in objectively evaluating and enhancing their workplace environments. This year, over 2,300 organizations from 121 countries and regions worldwide received the prestigious Top Employers certification for 2024. 
            </p>
            <p className="pb-5">
            Despite the challenging geopolitical climate, the Top Employers Institute and its leaders have remained unwavering in their commitment to recognizing stability and reliability among top employers. CEO David Plink emphasizes: “Amidst rapid geopolitical, societal, and macro-economic changes, the Top Employers of 2024 continue to serve as a beacon of stability and reliability. Their steadfast dedication to creating exceptional workplaces, even in turbulent times, is truly commendable.”
            </p>
            <div className="font-markWebPro text-xl pb-1 text-topHead">
            Nathier Jappie
            </div>
            <div className="font-markScForMCNarrowM">
            Regional Manager: Africa, Top Employers Institute
             </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Nathier;
